import * as rpc from '@platform/components/rpc';
import config from '@platform/shared/config';
import { UserStore } from '@platform/store';
import type { RpcFilters } from '@platform/shared/rpc';
import { DataType, NodeAPI } from '@platform/shared/rpc';

export async function sysGetMetadata(params?: {
    forSelectField?: boolean;
    sys_metadata_field_name_in?: string[];
    filters?: RpcFilters;
}) {
    try {
        const sys_metadata_field_name_in_str: any[] = [];
        if (params?.sys_metadata_field_name_in) {
            for (const item of params?.sys_metadata_field_name_in ?? []) {
                if (item) sys_metadata_field_name_in_str.push("'" + item + "'");
            }
        }

        const query_response = await NodeAPI.Rpc.callFunction({
            fn: 'platform.sys_get_metadata',
            args: {
                sys_service_id_in: { type: 'uuid', value: config.serviceId },
                sys_org_id_in: { type: 'uuid', value: UserStore.userState.sysParams.sysOrgId },
                // sys_metadata_field_name_in: {
                //     type: 'varchar[]',
                //     value: params?.sys_metadata_field_name_in?.length ? [sys_metadata_field_name_in_str] : null,
                // },
                only_with_doc_states_in: {
                    type: 'boolean',
                    value: params?.sys_metadata_field_name_in?.length ? true : false,
                },
            },
            struct: {
                // ...table_query.tableStructure,
                id: { dataType: DataType.UUID },
                sys_row_status: { dataType: DataType.VARCHAR },
                name: { dataType: DataType.VARCHAR },
                table_schema: { dataType: DataType.VARCHAR },
                table_name: { dataType: DataType.VARCHAR },
                is_system: { dataType: DataType.BOOLEAN },
                is_need_to_copy: { dataType: DataType.BOOLEAN },
                is_function: { dataType: DataType.BOOLEAN },
                sys_metadata_parent_id: { dataType: DataType.UUID },
            },
            options: {
                filters: params?.filters,
            },
        });

        if (!query_response?.length) return [];

        if (!params?.forSelectField) return query_response;

        const rowData: any[] = [];
        query_response.forEach((item: any) => {
            rowData.push({
                label: item.name,
                value: item.id,
                name: item.name,
                table_schema: item.table_schema,
                table_name: item.table_name,
                schemaName: `${item.table_schema ?? '-'}.${item.table_name ?? '-'}`,
            });
        });

        rowData.sort(function (a: any, b: any) {
            if (a.name > b.name) {
                return 1;
            }
            if (a.name < b.name) {
                return -1;
            }
            // a должно быть равным b
            return 0;
        });

        return rowData;
    } catch (e) {
        console.warn(e);
    }
}

export async function sysGetMetadataSysParamsSysDocState(params: {
    forSelectField?: boolean;
    sys_metadata_field_name_in?: string[];
    sqlFilter?: string[] | RpcFilters;
    forRoleId?: string | null;
}) {
    try {
        const table_query = {
            tableStructure: [
                rpc.getTableStructureItem('platform', 'metadata', 'id', 'uuid'),
                rpc.getTableStructureItem('platform', 'metadata', 'sys_row_status', 'character varying'),
                rpc.getTableStructureItem('platform', 'metadata', 'name', 'character varying'),
                rpc.getTableStructureItem('platform', 'metadata', 'table_schema', 'character varying'),
                rpc.getTableStructureItem('platform', 'metadata', 'table_name', 'character varying'),
                rpc.getTableStructureItem('platform', 'metadata', 'is_system', 'boolean'),
                rpc.getTableStructureItem('platform', 'metadata', 'is_need_to_copy', 'boolean'),
                rpc.getTableStructureItem('platform', 'metadata', 'is_function', 'boolean'),
                rpc.getTableStructureItem('platform', 'metadata', 'sys_doc_state_count', 'numeric'),
                rpc.getTableStructureItem('platform', 'metadata', 'sys_metadata_parent_id', 'uuid'),
                rpc.getTableStructureItem(
                    'platform',
                    'sys_metadata',
                    'name',
                    'character varying',
                    'sys_metadata_parent_id',
                    1
                ),
            ],
            sqlFilter: params.sqlFilter ?? null,
        };

        const sys_metadata_field_name_in_str: any[] = [];
        if (params?.sys_metadata_field_name_in) {
            for (const item of params?.sys_metadata_field_name_in ?? []) {
                if (item) sys_metadata_field_name_in_str.push("'" + item + "'");
            }
        }

        const query_response = await rpc.do_rpc_query(
            'read',
            `sys_get_metadata_params_sys_doc_state('${config.serviceId}'::uuid, '${
                UserStore.userState.sysParams.sysOrgId
            }'::uuid, ${params.forRoleId ? `'${params.forRoleId}'` : 'NULL'}::uuid)`,
            table_query,
            null,
            null,
            'platform'
        );
        if (!query_response?.length) return [];

        if (!params?.forSelectField) return query_response;

        const rowData: any[] = [];
        query_response.forEach((item: any) => {
            rowData.push({
                label: item.name,
                value: item.id,
                name: item.name,
                table_schema: item.table_schema,
                table_name: item.table_name,
                schemaName: `${item.table_schema ?? '-'}.${item.table_name ?? '-'}`,
                sys_doc_state_count: item.sys_doc_state_count,
            });
        });

        rowData.sort(function (a: any, b: any) {
            if (a.name > b.name) {
                return 1;
            }
            if (a.name < b.name) {
                return -1;
            }
            // a должно быть равным b
            return 0;
        });

        return rowData;
    } catch (e) {
        console.warn(e);
    }
}
